<i18n>
{
  "ja":{
    "参加する一覧":"参加する一覧",
    "学ぶ一覧":"学ぶ一覧",
    "コンテンツ":"コンテンツ"
  },
  "en":{
    "参加する一覧":"Events",
    "学ぶ一覧":"Library",
    "コンテンツ":"Article"
  }
}
</i18n>
<template lang="pug">
.SectionContents
  .loading(v-if="!sections || !sections.length")
    img(src="@/assets/images/loading.gif")
  section(v-for="(item, sectionIndex) in sections")
    //- サブタイトル
    h2(v-if="item.subtitle") {{item.subtitle}}
    //- フリーコメント
    .description(v-if="item.comment" v-html="$options.filters.text2html(item.comment)")

    //- 画像
    ImageViewerWithThumbnail(:images="item.images" :uid="sectionIndex")

    //- 動画(本番orステージング環境でのみ動作確認)
    .video-content(v-for="video in item.videos")
      video(class="video-js" ref="videoElm" :data-videoId="video.videoID" :poster="video.thumbnailImageUrl")
        source(:src="video.videoUrl" type="application/x-mpegURL")

    //- .pdf添付ファイル
    .attachment(v-if="item.attachments && item.attachments.length")
      .attachment-area.pc
        ul
          li(v-for="file in item.attachments")
            .name {{file.fileName}}
            a.link(:href="file.url" target="_blank" @click="notifyViewReportArticleResource(null, file.id)") {{$t("詳しく見る")}}
      .attachment-area.sp
        ul
          li(v-for="file in item.attachments")
            a.link(:href="file.url" target="_blank" @click="notifyViewReportArticleResource(null, file.id)")
              span.name {{file.fileName}}
    //- リンクさせたいコンテンツ - イベント
    .reltype-link(v-if="item.relType=='Events'")
      router-link(:to="{name: 'event', params: {id: item.relObjectID} }")
        button.middle-button-style.blue-button.w-100 {{$t("イベント")}}

    //- リンクさせたいコンテンツ - イベント一覧
    .reltype-link(v-if="item.relType=='EventList'")
      router-link(:to="{name: 'events'}")
        button.middle-button-style.blue-button.w-100 {{$t("参加する一覧")}}

    //- リンクさせたいコンテンツ - お知らせ
    .reltype-link(v-if="item.relType=='Announcements'")
      router-link(:to="{name: 'announcement', params: {id: item.relObjectID} }")
        button.middle-button-style.blue-button.w-100 {{$t("お知らせ")}}

    //- リンクさせたいコンテンツ - 学ぶ
    .reltype-link(v-if="item.relType=='ReportArticles'")
      router-link(:to="{name: 'library', params: {id: item.relObjectID} }")
        button.middle-button-style.blue-button.w-100 {{$t("コンテンツ")}}

    //- リンクさせたいコンテンツ - 学ぶ一覧
    .reltype-link(v-if="item.relType=='ReportArticleList'")
      router-link(:to="{name: 'libraries'}")
        button.middle-button-style.blue-button.w-100 {{$t("学ぶ一覧")}}

    //- リンクさせたいコンテンツ - 学ぶ一覧(タグ)
    .reltype-link(v-if="item.relType=='TaggedReportArticles'")
      router-link(:to="{name: 'libraryTag', params: {id: item.relObjectID}}")
        button.middle-button-style.blue-button.w-100 {{$t("学ぶ一覧")}}

    //- リンクさせたいコンテンツ - アンケート
    .reltype-link(v-if="item.relType=='Questionnaire'")
      router-link(:to="{name: 'survey', params: {id: item.relObjectID} }")
        button.middle-button-style.blue-button.w-100 {{$t("アンケート")}}

</template>
<script>
import ImageViewerWithThumbnail from '@/components/ImageViewerWithThumbnail'
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
export default {
  components: {
    ImageViewerWithThumbnail,
  },
  props: [
    'sections',
    'libraryId', // 非必須。ライブラリーのみidを渡す
  ],
  data() {
    return {
      isMovieMounted: false,
      players: [],
    }
  },
  methods: {
    mountMovies() {
      console.log('mount movies')
      const options = {
        autoplay: false,
        controls: true,
        fluid: true,
        playbackRates: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2.0],
      }
      if (this.$refs.videoElm) {
        this.$refs.videoElm.forEach(elm => {
          const player = videojs(elm, options, function onPlayerReady() {
            console.log('onPlayerReady', this)
          })
          if (this.libraryId) {
            player.on('play', () => {
              const videoId = elm.getAttribute('data-videoId')
              this.notifyViewReportArticleResource(videoId, null)
              console.log('play', videoId)
            })
          }
          this.players.push(player)
        })
        this.isMovieMounted = true
      }
    },
    notifyViewReportArticleResource(videoId, attachmentId) {
      if (this.libraryId) {
        const libraryId = this.libraryId
        this.api(
          'notifyViewReportArticleResource',
          { libraryId, videoId, attachmentId },
          rv => {
            if (!rv || !rv.succeed) {
              console.log(rv, '失敗')
            } else {
              console.log(rv, '成功')
            }
          }
        )
      }
    },
  },
  mounted() {
    console.log('mounted')
    if (!this.isMovieMounted) this.mountMovies()
  },
  updated() {
    console.log('updated')
    if (!this.isMovieMounted) this.mountMovies()
  },
  beforeDestroy() {
    if (this.players.length) {
      this.players.forEach(player => {
        player.dispose()
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.loading {
  text-align: center;
  padding: 100px;
}
.attachment-area {
  margin: 30px 0 80px;
}
.video-content {
  margin-bottom: 30px;
}
.click-thumbnail-lists {
  margin-bottom: 50px;
}
</style>
